import React, { useState } from "react";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import Table from "../../components/Table";
import { DateInput } from "../../components/Form";
import { Card, CardContent, CardActions } from "../../components/Card";
import { useAlert } from "../../components/Alert";

const GET_CRAWLERRECORDS = gql`
  query crawlerRecords(
    $startDate: Date
    $endDate: Date
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    crawlerRecords(
      startDate: $startDate
      endDate: $endDate
      latest: $latest
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        source
        startedAt
        endedAt
        successCount
        errorCount
        failCount
        errorLog
        createdAt
      }
    }
  }
`;

export default function CrawlerRecordTable() {
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const Alert = useAlert();

  const { data, loading } = useQuery(GET_CRAWLERRECORDS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      startDate,
      endDate,
      latest: true,
      pageSize: 10,
      page,
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                日期
              </Typography>
              <DateInput
                format="yyyy年MM月dd日"
                value={startDate}
                onChange={(v) => setStartDate(v)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                至
              </Typography>
              <DateInput
                format="yyyy年MM月dd日"
                value={endDate}
                minDate={startDate}
                onChange={(v) => setEndDate(v)}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Table
            data={data?.crawlerRecords?.contents}
            tableWidth={2}
            header={[
              "編號",
              "來源",
              "執行開始時間",
              "執行結束時間",
              "成功筆數",
              "錯誤筆數",
              "失敗筆數",
              "錯誤原因",
            ]}
            columns={[
              (_, index) => index + 1,
              (item) => item.source,
              (item) => moment(item.startedAt).format("yyyy-MM-DD"),
              (item) => moment(item.endedAt).format("yyyy-MM-DD"),
              (item) => item.successCount,
              (item) => item.errorCount,
              (item) => item.failCount,
              (item) => item.errorLog,
            ]}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.crawlerRecords?.pageCount
                  ? data.crawlerRecords.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
